import getConstants from '../constants'

export const convertTime = (time: string, toMilitary: boolean): string => {
  const amFormat = getConstants().AM_FORMAT
  const pmFormat = getConstants().PM_FORMAT

  if (toMilitary) {
    return time
  } else {
    const splittedTime = time.split(':')

    if (Number(splittedTime[0]) < 12) {
      return `${splittedTime[0].toString()}:${splittedTime[1]}${amFormat}`
    } else if (Number(splittedTime[0]) === 12) {
      return `${splittedTime[0].toString()}:${splittedTime[1]}${pmFormat}`
    } else {
      const numPeriod = Math.floor(Number(splittedTime[0]) / 12)
      const isAm = numPeriod % 2 == 0

      return `${(Number(splittedTime[0]) - 12 * numPeriod).toString()}:${
        splittedTime[1]
      }${isAm ? amFormat : pmFormat}`
    }
  }
}

export const convertStoreHours = (
  openHours: string,
  closeHours: string,
  toMilitary: boolean,
): string => {
  if (!openHours || !closeHours) {
    return ''
  }
  return `${convertTime(openHours, toMilitary)} - ${convertTime(
    closeHours,
    toMilitary,
  )}`
}
